import React from 'react';

import type { BaseComponentProps } from '@coursera/cds-common';

import { getAccordionPanelCss } from './accordionPanelCss';

export type AccordionPanelElement = React.ReactElement<
  Props,
  typeof AccordionPanel
>;

export type Props = BaseComponentProps<'div'>;

/**
 * The content panel of an Accordion, which can be collapsed by an
 * AccordionHeader.
 *
 * See
 * [Engineering notes](__storybookUrl__/components-surfaces-accordion--default#eng-notes)
 * and
 * [Props](__storybookUrl__/components-surfaces-accordion--default#props) for details.
 *
 * @see Accordion
 * @see AccordionHeader
 */
const AccordionPanel = React.forwardRef(function AccordionPanel(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} css={getAccordionPanelCss} {...rest}>
      {children}
    </div>
  );
});

export default AccordionPanel;
